import { UsersListFilterInput } from 'gql/types';
import { TFunction } from 'i18next';
import { FiltersConfig } from 'modules/common/components/FilterChips/types';
import { formatEnum } from 'modules/common/utils/formatEnum';

export const createInternalUsersChipsConfig = (
  t: TFunction
): FiltersConfig<UsersListFilterInput> => ({
  roles: {
    label: t('role'),
    renderValue: formatEnum,
  },
});

export const excludedFilterFields: (keyof UsersListFilterInput)[] = [
  'searchingQuery',
  'username',
  'isArchived',
  'ids',
  'isDeleted',
  'ownerTypes',
  'productRegionPreferenceId',
];
